import axios from "axios";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const posApi = axios.create({ baseURL: BASE });
posApi.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("pos_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});
export const posErr = (e) => e?.response?.data?.detail || e?.message || "Something went wrong";
export const isNetworkError = (e) => !e?.response;
